import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
/** @class CardSectionMixin */

/** @method */

export var CardSectionMixin = function CardSectionMixin(props) {
  return token("Card.separatorColor", function (borderColor) {
    return css(["border-bottom:1px solid ", ";padding-bottom:", ";margin-bottom:", ";&:last-of-type{border-bottom:0;padding-bottom:0;margin-bottom:0;}", ""], borderColor, spaceMixin("md")(props), spaceMixin("md")(props), spacingMixin(props));
  })(props);
};